import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue')
  },
  {
    path: '/admin',
    component: () => import('@/views/AdminLayout.vue'),
    meta: { requiresAuth: true },
    redirect: '/admin/products',
    children: [
      {
        path: 'products',
        name: 'ProductManagement',
        component: () => import('@/views/ProductManagement.vue')
      },
      {
        path: 'admins',
        name: 'AdminManagement',
        component: () => import('@/views/AdminManagement.vue')
      }
    ]
  },
  {
    path: '/product/:id',
    name: 'ProductDisplay',
    component: () => import('@/views/ProductDisplay.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    redirect: '/login'
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else if (to.path === '/login' && token) {
    next('/admin/products')
  } else {
    next()
  }
})

export default router

